// import { useState, useEffect } from "react";
// import { useAuth } from "../Context/AuthContext";
// import ErrorMessage from "../Helpers/ErrorMessage";
// import API from "../Context/api";
// import { v4 as uuidv4 } from "uuid";

// const CloseComputerForm = ({
//   computerId,
//   setIsModalOpen,
//   handleComputerUpdated,
// }) => {
//   const { user } = useAuth();
//   const createdBy = user ? user.name : "";
//   const userId = user ? user.userId : "";

//   const [isLoading, setIsLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [originalData, setOriginalData] = useState(null); // 🔥 NEW STATE

//   const [repairDetails, setRepairDetails] = useState("");
//   const [recommendations, setRecommendations] = useState("");

//   //   // 🔄 Fetch technicians and original computer data
//   useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true);
//       try {
//         const computerResponse = await API.get(`/computers/${computerId}`);
//         const data = computerResponse.data;

//         console.log(data);
//         setOriginalData(computerResponse.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setErrorMessage("Failed to load computer data or technicians");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchData();
//   }, [computerId, createdBy]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Creating the new objects for changeHistory and repairHistory directly with UUIDs
//     const submissionData = {
//       ...originalData, // Spread original data
//       isFaulty: false,
//       isRepaired: true,
//       changeHistory: [
//         ...originalData.changeHistory, // Keep existing changeHistory data
//         {
//           date: new Date().toISOString(),
//           changehistoryid: uuidv4(), // Generate unique ID for changeHistory
//           computerid: originalData.computerId, // Use fetched computerId
//           changedby: createdBy,
//           field: "repairdetails",
//           oldvalue: originalData.repairDetails.repairdetails, // Use existing status from repairDetails
//           newvalue: repairDetails, // Direct change of status
//           created: new Date().toISOString(),
//           createdby: createdBy,
//         },
//         {
//           date: new Date().toISOString(),
//           changehistoryid: uuidv4(), // Generate unique ID for changeHistory
//           computerid: originalData.computerId, // Use fetched computerId
//           changedby: createdBy,
//           field: "recommendations",
//           oldvalue: originalData.repairDetails.recommendations, // Use existing status from repairDetails
//           newvalue: recommendations, // Direct change of status
//           created: new Date().toISOString(),
//           createdby: createdBy,
//         },
//       ],
//       repairDetails: {
//         title: `${originalData.name} - Repair ${originalData.inventoryTrackingNumber}`, // Use dynamic title
//         repairdetails: repairDetails, // Use the repair details from state
//         computerid: originalData.computerId, // Directly use computerId from fetched data
//         resourceassigned: originalData.repairDetails.resourceassigned, // Example value, you can replace with real data
//         status: "completed", // Directly assigning the repair status
//         date: new Date().toISOString(),
//         recommendations: recommendations, // Use the recommendations state
//         companyassettag: originalData.companyAssetTag, // Use companyAssetTag from fetched data
//         repairid: uuidv4(), // Generate unique ID for repairDetails
//         created: new Date().toISOString(),
//       },
//       repairHistory: [
//         ...originalData.repairHistory, // Keep existing repairHistory data
//         {
//           title: "Completed Repair", // Direct title
//           serialnumber: originalData.serialNumber, // Use existing serial number from fetched data
//           date: new Date().toISOString(),
//           description: "Replaced faulty hardware", // Example description
//           status: "Completed", // Direct status
//           repairhistoryid: uuidv4(), // Generate unique ID for repairHistory
//           computerid: originalData.computerId,
//           created: new Date().toISOString(),
//           createdby: createdBy,
//         },
//       ],
//     };
//     console.log(submissionData);

//     try {
//       // const closeData = {
//       //   repairDetails: repairDetails,
//       //   recommendations: recommendations,
//       // };

//       await API.put(`/computers/${computerId}/close`, submissionData);

//       const taskId = submissionData.taskId;

//       // 🔥 Delete specific task assigned to the old tech
//       await API.delete(`/users/tasks/${userId}/${taskId}`);

//       // 💾 Update the computer
//       // await API.put(`/computers/${id}`, submissionData);

//       handleComputerUpdated(); // Refresh inventory
//       setIsModalOpen(false); // Close modal
//     } catch (error) {
//       console.error("Error closing computer repair:", error);
//       alert("Failed to close computer repair.");
//     }
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
//       <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
//         <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
//           <h2 className="text-xl font-bold mb-4">Close Computer Repair</h2>
//           <form onSubmit={handleSubmit}>
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700">
//                 Repair Details
//               </label>
//               <textarea
//                 value={repairDetails}
//                 onChange={(e) => setRepairDetails(e.target.value)}
//                 className="mt-1 p-2 border rounded w-full"
//                 rows="4"
//                 required
//               />
//             </div>
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700">
//                 Recommendations
//               </label>
//               <textarea
//                 value={recommendations}
//                 onChange={(e) => setRecommendations(e.target.value)}
//                 className="mt-1 p-2 border rounded w-full"
//                 rows="3"
//               />
//             </div>
//             <div className="flex justify-end space-x-2">
//               <button
//                 type="submit"
//                 className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
//               >
//                 Complete Repair
//               </button>
//               <button
//                 type="button"
//                 onClick={() => setIsModalOpen(false)}
//                 className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CloseComputerForm;

import { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import ErrorMessage from "../Helpers/ErrorMessage";
import API from "../Context/api";
import { v4 as uuidv4 } from "uuid";
import Spinner from "../Helpers/Spinner";

const CloseComputerForm = ({
  computerId,
  setIsModalOpen,
  handleComputerUpdated,
}) => {
  const { user } = useAuth();
  const createdBy = user ? user.name : "";
  const userId = user ? user.userId : "";
  const [isFetching, setIsFetching] = useState(false); // For fetching data
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [originalData, setOriginalData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // 🔥 NEW STATE for form submission

  const [repairDetails, setRepairDetails] = useState("");
  const [recommendations, setRecommendations] = useState("");

  const initialFormData = {
    name: "",
    serialNumber: "",
    make: "",
    model: "",
    client: "",
    resourceAssigned: "",
    repairStatusType: "In Repair",
    problemDescription: "",
    repairStatusDate: new Date().toISOString(),
    companyAssetTag: "",
    repairHistory: [],
    changeHistory: [],
    repairDetails: "",
    createdBy,
    taskID: "",
    computerID: "",
    inventoryTrackingNumber: "",
    isFaulty: false,
    isRepaired: false,
    repairDetails: "",
    recommendations: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [originalFormData, setOriginalFormData] = useState(initialFormData);
  let TaskID = "";

  // Fetch technicians and computer data on mount
  useEffect(() => {
    const fetchData = async () => {
      setIsFetching(true);
      try {
        const computerResponse = await API.get(`/computers/${computerId}`);

        const item = computerResponse.data;
        const taskId = item.fields.TaskID;

        const transformed = {
          name: item.fields.Name || "",
          serialNumber: item.fields.SerialNumber || "",
          make: item.fields.Make || "",
          model: item.fields.Model || "",
          client: item.fields.Client || "",
          resourceAssigned: item.repairDetails?.ResourceAssigned || "",
          repairStatusType: item.repairDetails?.Status || "In Repair",
          problemDescription: item.repairDetails?.ProblemDescription || "",
          repairStatusDate:
            item.repairDetails?.Date || new Date().toISOString(),
          companyAssetTag: item.fields.CompanyAssetTag || "",
          repairHistory: item.repairHistory || [],
          changeHistory: item.changeHistory || [],
          createdBy: item.fields.CreatedBy || "",
          taskID: item.fields.TaskID || "",
          computerID: item.fields.ComputerID || "",
          inventoryTrackingNumber: item.fields.InventoryTrackingNumber || "",
          isFaulty: item.fields.IsFaulty || false,
          isRepaired: item.fields.IsRepaired || false,
          repairDetails: item.repairDetails?.RepairDetails || "", // flatten
          recommendations: item.repairDetails?.Recommendations || "", // flatten
        };

        setFormData(transformed);
        setOriginalFormData(transformed);

        // // Now fetch task using taskId directly
        // if (taskId) {
        //   const singleTask = await API.get(`/tasks/${taskId}`);
        //   // console.log("singleTask", singleTask.data.taskId);
        //   TaskID = singleTask.data.taskId;
        //   // set some other task-related state if needed
        // }
      } catch (error) {
        // console.error("Error fetching data:", error);
        setErrorMessage("Failed to load computer data or technicians");
        console.log(error);
      } finally {
        setIsFetching(false);
      }
    };
    fetchData();
  }, [computerId, createdBy]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Validate required fields
  const requiredFields = ["repairDetails", "recommendations"];
  const isFormValid = requiredFields.every((field) => formData[field]?.trim());

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    const missingFields = requiredFields.filter(
      (field) => !formData[field]?.trim()
    );

    if (missingFields.length > 0) {
      setErrorMessage(
        `Please fill in required fields: ${missingFields.join(", ")}`
      );
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");

    try {
      // 3️⃣ Prepare data for updating computer, repair, and history
      const computerId = formData.computerID; // from SharePoint/computer record
      const repairId = formData.repairId; // make sure this is populated during fetch
      const inventoryTrackingNumber = formData.inventoryTrackingNumber; // keep existing

      const fields = {
        Title: `${formData.name}`,
        Name: formData.name,
        Client: formData.client,
        Model: formData.model,
        SerialNumber: formData.serialNumber,
        InventoryTrackingNumber: inventoryTrackingNumber,
        Make: formData.make,
        ComputerID: computerId,
        CreatedBy: createdBy,
        IsFaulty: false,
        IsRepaired: true,
        CompanyAssetTag: formData.companyAssetTag,
        TaskID: formData.taskID,
      };

      const repairDetails = {
        Title: `Repair - ${formData.name}`,
        RepairDetails: formData.repairDetails,
        ComputerID: computerId,
        ResourceAssigned: formData.resourceAssigned,
        Status: "Completed",
        Date: formData.repairStatusDate,
        Recommendations: formData.recommendations,
        CompanyAssetTag: formData.companyAssetTag,
        RepairID: repairId,
        ProblemDescription: formData.problemDescription,
      };

      // Track change history
      let updatedChangeHistory = [...formData.changeHistory];
      const fieldsToTrack = ["repairDetails", "recommendations"];

      fieldsToTrack.forEach((field) => {
        const oldValue = originalFormData[field] ?? "";
        const newValue = formData[field] ?? "";
        if (String(oldValue) !== String(newValue)) {
          updatedChangeHistory.push({
            Title: `${field} updated`,
            Date: new Date().toISOString(),
            ChangeHistoryID: uuidv4(),
            ComputerID: formData.computerID, // use existing ID
            ChangedBy: createdBy,
            Field: field,
            OldValue: oldValue,
            NewValue: newValue,
          });
        }
      });

      let updatedRepairHistory = [...formData.repairHistory];

      const newRepairHistoryEntry = {
        Title: `Repair Update - ${formData.name}`,
        SerialNumber: formData.serialNumber,
        Date: new Date().toISOString(),
        Description: `${formData.repairDetails} ${formData.recommendations}`,
        Status: formData.repairStatusType,
        RepairHistoryID: uuidv4(),
        ComputerID: formData.computerID,
      };

      updatedRepairHistory.push(newRepairHistoryEntry);

      const submissionData = {
        fields,
        repairDetails,
        changeHistory: updatedChangeHistory,
        repairHistory: updatedRepairHistory,
      };

      await API.put(`/computers/${computerId}/close`, submissionData);
      const taskId = submissionData.fields.TaskID;

      await API.delete(`/tasks/${taskId}`);

      // // Delete the task
      // if (taskId && computerId) {
      //   // await API.delete(`/tasks/${computerToDelete}/${taskId}`);
      //   await API.delete(`/tasks/${taskId}/${computerId}`);
      // }

      handleComputerUpdated();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error closing computer repair:", error);
      alert("Failed to close computer repair.");
    } finally {
      setIsSubmitting(false); // End loading
    }
  };

  console.log(formData);

  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
    //   <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
    //     <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
    //       <h2 className="text-xl font-bold mb-4">Close Computer Repair</h2>
    //       <form onSubmit={handleSubmit}>
    //         <div className="mb-4">
    //           <label className="block text-sm font-medium text-gray-700">
    //             Repair Details
    //           </label>
    //           <textarea
    //             value={repairDetails}
    //             onChange={(e) => setRepairDetails(e.target.value)}
    //             className="mt-1 p-2 border rounded w-full"
    //             rows="4"
    //             required
    //             disabled={isSubmitting} // Disable during submission
    //           />
    //         </div>
    //         <div className="mb-4">
    //           <label className="block text-sm font-medium text-gray-700">
    //             Recommendations
    //           </label>
    //           <textarea
    //             value={recommendations}
    //             onChange={(e) => setRecommendations(e.target.value)}
    //             className="mt-1 p-2 border rounded w-full"
    //             rows="3"
    //             disabled={isSubmitting} // Disable during submission
    //           />
    //         </div>
    //         <div className="flex justify-end space-x-2">
    //           <button
    //             type="submit"
    //             className={`bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 flex items-center ${
    //               isSubmitting ? "opacity-50 cursor-not-allowed" : ""
    //             }`}
    //             disabled={isSubmitting} // Disable button
    //           >
    //             {isSubmitting ? (
    //               <>
    //                 <svg
    //                   className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
    //                   xmlns="http://www.w3.org/2000/svg"
    //                   fill="none"
    //                   viewBox="0 0 24 24"
    //                 >
    //                   <circle
    //                     className="opacity-25"
    //                     cx="12"
    //                     cy="12"
    //                     r="10"
    //                     stroke="currentColor"
    //                     strokeWidth="4"
    //                   ></circle>
    //                   <path
    //                     className="opacity-75"
    //                     fill="currentColor"
    //                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    //                   ></path>
    //                 </svg>
    //                 Processing...
    //               </>
    //             ) : (
    //               "Complete Repair"
    //             )}
    //           </button>
    //           <button
    //             type="button"
    //             onClick={() => setIsModalOpen(false)}
    //             className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
    //             disabled={isSubmitting} // Disable cancel during submission
    //           >
    //             Cancel
    //           </button>
    //         </div>
    //       </form>
    //     </div>
    //   </div>
    // </div>

    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
      <div className="w-full max-h-[80vh] p-4 max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
        <div className="h-full flex flex-col">
          {isFetching && (
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10">
              <Spinner />
            </div>
          )}
          {/* Static Header */}
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
            Close Computer Repair
          </h2>
          <ErrorMessage message={errorMessage} />

          {/* Scrollable Content */}
          <div className="flex-1 overflow-y-auto space-y-3 max-h-[calc(80vh-150px)]">
            <form onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="repairDetails"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Repair Details
                </label>
                <textarea
                  id="repairDetails"
                  name="repairDetails"
                  value={formData.repairDetails}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  rows={4}
                />
              </div>

              <div>
                <label
                  htmlFor="recommendations"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Recommendations
                </label>
                <textarea
                  id="recommendations"
                  name="recommendations"
                  value={formData.recommendations}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  rows={4}
                />
              </div>
            </form>
          </div>

          {/* Action buttons */}
          <div className="flex justify-end gap-3 mt-2">
            <button
              type="button"
              onClick={() => setIsModalOpen(false)}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
            >
              Cancel
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={!isFormValid || isSubmitting}
              className={`px-4 py-2 rounded-md text-sm font-semibold w-full sm:w-auto transition duration-200 ${
                !isFormValid || isSubmitting
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-800"
              }`}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloseComputerForm;
